module.exports = __webpack_public_path__ + "static/media/yossif.faa637cf.JPG";